export default {
  namespaced: true, // This enables namespacing for this module
  state: {
    isSidebarOpen: false,  // Initial state of the sidebar
    isNotificationOpen: false, // Initial state of the notification drawer
  },
  mutations: {
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    toggleNotification(state) {
      state.isNotificationOpen = !state.isNotificationOpen;
    }
  },
  actions: {
    toggleSidebar({ commit }) {
      commit('toggleSidebar');
    },
    toggleNotification({ commit }) {
      commit('toggleNotification');
    },
  },
  getters: {
    isSidebarOpen: (state) => state.isSidebarOpen,
    isNotificationOpen: (state) => state.isNotificationOpen, // Corrected getter
  },
};
